const SUPPORT_CASE_URL = '/support-cases';

export default SUPPORT_CASE_URL;
